module.exports = __webpack_public_path__ + "static/media/Crest.f8ca78e3.png";